require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// /Users/jb/Code/grupob/~/core-js/modules/es6.array.species.js
// module id = 165
// module chunks = 0